'use client';
import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa6';

const ShopSidebarColor = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleClick = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <div
      className={`sidebar-filter sidebar-filter--color sidebar-filter--collapsible mb-40 ${isCollapsed ? 'is-collapsed' : ''}`}
    >
      <div className="sidebar-filter__header">
        <h3 className="sidebar-filter__title">Color</h3>
        <button
          onClick={handleClick}
          className="sidebar-filter__toggle btn btn-link p-0"
          aria-expanded={!isCollapsed}
          aria-controls="color-filter-content"
        >
          <FaChevronDown />
        </button>
      </div>

      <div id="color-filter-content" className="sidebar-filter__content">
        <ul className="sidebar-filter__list list-unstyled">
          {[
            { id: 'red-check', label: 'Red', checked: true },
            { id: 'green-check', label: 'Green' },
            { id: 'yellow-check', label: 'Yellow' },
            { id: 'blue-check', label: 'Blue' },
          ].map((color, i: number) => (
            <li key={i} className="sidebar-filter__item">
              <div className="form-check">
                <div className="check-group flex-grow-1">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={color.id}
                    defaultChecked={color.checked}
                  />
                  <label
                    className="form-check-label d-block"
                    htmlFor={color.id}
                  >
                    {color.label}
                  </label>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ShopSidebarColor;
